import React from "react";
import studentsAPI from "../../../../services/students";
import MeaLoadingContent from "../../../../components/MeaLoadingContent";
import { DataView } from "primereact/dataview";
import MeaMemberAvatar from "../../../../components/MeaMemberAvatar";
import { ToFormatedDateForEvents } from "../../../../utils/dates";
import { formatChangeValue, getFieldDisplayName, isEmptyChangeValue } from "./studentUpdatesHistoryFormat";

const StudentUpdatesHistoryListComponent = ({ schoolId, trainingId, student }) => {

  const query = studentsAPI.GetUpdatesHistory(schoolId, trainingId, "", student?.id);

  if (query.isLoading) {
    return <MeaLoadingContent objectQuery={query} />;
  }

  if (query.isError) {
    return <div>{query.error}</div>;
  }

  const updates = query.data?.data;


  const renderChangeItem = (change) => {
    return (
      <li>
        <strong className="mr-2">
          {getFieldDisplayName(change.field_name)}:
        </strong>
        {!isEmptyChangeValue(change, "original") && (
          <>
            <span className="text-500">{formatChangeValue(change, "original")}</span>
            <i className="pi pi-arrow-right text-xs mx-2" aria-label="devient" />
          </>
        )}
        <span>{formatChangeValue(change, "new")}</span>
      </li>
    );
  };

  const itemTemplate = (update, index) => {
    return (
      <div className="col-12" key={index}>
        <div className="mb-2 pb-1 border-bottom-1 border-gray-200">
          <div className="flex align-items-center">
            <MeaMemberAvatar member={update.member} schoolId={schoolId} trainingId={trainingId} />
            <span className="ml-2">
              {update.member_name} a fait une modification le {ToFormatedDateForEvents(new Date(update?.created_at), false)}
            </span>
          </div>
          <div className="p-card-body">
            <ul>
              {JSON.parse(update?.changes).map((change, idx) => (
                <React.Fragment key={idx}>
                  {renderChangeItem(change)}
                </React.Fragment>
              ))}
            </ul>

          </div>
        </div>
      </div>
    );
  };

  const listTemplate = (items) => {
    if (!items || items?.length === 0) {
      return (
        <div className="p-3 border-1 border-round border-300 bg-gray-50 text-700">
          Aucun historique de modification n'est disponible pour cet élève.
        </div>
      );
    }

    let list = items?.map((update, index) => {
      return itemTemplate(update, index);
    });

    return <div className="grid grid-nogutter">{list}</div>;
  };

  return (
    <div>
      <DataView value={updates} listTemplate={listTemplate} emptyMessage="Aucun historique de modification n'est disponible pour cet élève."/>
    </div>
  );
};

export default StudentUpdatesHistoryListComponent;